function Input({
  size = "md",
  className = "",
  ...props
}) {
  const sizes = {
    sm:
      "w-full max-w-full sm:w-20 text-[12px] sm:text-sm",
    md:
      "w-full max-w-full sm:w-52 text-[12px] sm:text-sm",
    lg:
      "w-full max-w-full sm:w-72 text-[12px] sm:text-sm",
  };

  return (
    <input
      {...props}
      className={`
	        border
	        border-slate-300
	        rounded-lg
	        px-2
	        py-1
	        bg-white
	        text-[12px]
          sm:text-sm
          text-slate-900
	        focus:outline-none
	        focus:ring-2
	        focus:ring-blue-500
	        focus:border-blue-500
          placeholder:text-slate-400
	        ${sizes[size]}
	        ${className}
      `}
    />
  );
}

export default Input;
